<script lang="ts">
  import { END_COPY, MISSION_TICKS, ticksToClock } from "@spacecrew/shared";
  import { ship } from "../net/ship.svelte.js";
  import { leave } from "../net/session.svelte.js";
  import { send } from "../net/intents.js";

  const snap = $derived(ship.snap!);
  const won = $derived(snap.phase === "won");
</script>

<section class="end" aria-labelledby="end-title">
  <h1 id="end-title" class={won ? "" : "bad"}>{won ? "CONTRACT FULFILLED" : "ASSET LOST"}</h1>
  <p>{won ? END_COPY.won : END_COPY.lost}</p>
  <dl>
    <dt>ELAPSED</dt><dd>T+{ticksToClock(snap.tick)} / {ticksToClock(MISSION_TICKS)}</dd>
    <dt>RESERVE AT END</dt><dd>{snap.reserve.toFixed(1)} %</dd>
    <dt>CREW ABOARD</dt><dd>{Object.keys(snap.crew).length}</dd>
  </dl>
  <div class="actions">
    <button onclick={() => send("mission.restart", {})}>RESTART CONTRACT</button>
    <button onclick={() => void leave()}>RETURN TO DOCK</button>
  </div>
</section>

<style>
  .end { max-width: 60ch; padding: 1.5rem 1rem; }
  dl { display: grid; grid-template-columns: max-content 1fr; gap: 0.3rem 1rem; margin: 1rem 0; }
  dt { color: var(--fg-dim); }
  .actions { display: flex; gap: 0.6rem; flex-wrap: wrap; }
</style>
